import { AccessRequestType, AccessType, DriverRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * saveAcessesByCustomer - Function that saves on database accesses to new users  
 * /users/{customerType}  
 * method POST 
 * @async-function
 */
const saveAcessesByCustomer = async (token: string, model: AccessRequestType, customerType: string) => {
    const response = await api.post(
        `/users/${customerType}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default saveAcessesByCustomer;